import { getCreatorApiUrl } from '@client/components/api-urls';
import axios from 'axios';

export const sendEmailChallenge = async (
  email: string,
  intent?: 'login' | 'signup',
) => {
  const response = await axios.post(getCreatorApiUrl('/send-confirmation'), {
    email,
    intent,
  });
  return response.data;
};

export const confirmEmailCode = async (
  email: string,
  code: string,
): Promise<{ user: any; token?: string }> => {
  const response = await axios.post(getCreatorApiUrl('/confirm-email'), {
    email: email,
    code: code,
  });

  return response.data;
};

export const loginWithUsernamePassword = async (
  username: string,
  password: string,
) => {
  const response = await axios.post(getCreatorApiUrl('/auth/login'), {
    username: username,
    password: password,
  });

  return response.data;
};
